/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/scenario-mapper/scenario-variable',['require','underscore','screens/scenario-mapper/scenario-asset','screens/scenario-mapper/scenario-utils'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  //var $ = require('jquery');
  var _ = require('underscore');
  //var templates = require('core/templates');
  //var Scenario = require('screens/scenario-mapper/scenario');
  var ScenarioAsset = require('screens/scenario-mapper/scenario-asset');
  //var ScenarioUtils = require('ScenarioU');
  var Scenario;
  require(['screens/scenario-mapper/scenario'], function(a) {
    Scenario = a;
  });
  var ScenarioUtils;
  require(['screens/scenario-mapper/scenario-utils'], function(a) {
    ScenarioUtils = a;
  });

  if (false)
    return require('screens/scenario-mapper/scenario-utils');
  /*****************************************************************************************************************///}

  var ScenarioVariable = ScenarioAsset.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    name: null,
    initialValue: null,
    currentValue: null,
    description: null,

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    initialize: function(options)
    {
      ScenarioVariable.instancesArr.push(this);
      ScenarioAsset.prototype.initialize.apply(this, arguments);
    },

    setValue: function(value)
    {
      this.currentValue = value;
      if (this.name === 'points')
      {
        Scenario.updatePoints();
      }
    },

    onBeforeDestroy: function()
    {

    },

    parseData: function(data)
    {
      ScenarioAsset.prototype.parseData.apply(this, arguments);

      this.saType = ScenarioAsset.SA_TYPE_VARIABLE;

      this.name = data.Fields.Name;
      this.initialValue = ScenarioUtils.getValue(data.Fields['Initial Value']);
      this.currentValue = this.initialValue;
      this.description = data.Fields.Description;
    }

  /*****************************************************************************************************************///}

  });

  ScenarioVariable.instancesArr = [];
  ScenarioVariable.destroy = function()
  {
    _.each(ScenarioVariable.instancesArr, function(instance) {
      instance.destroy();
    });

    ScenarioVariable.instancesArr = [];
  };

  return ScenarioVariable;

});

